module.exports = __webpack_public_path__ + "img/contact2.e2e875d2.jpg";